"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../hooks");
var _CetComponentsProvider = require("../../../../../providers/CetComponentsProvider");
const useStyles = props => {
  const {
    pxToRem,
    setEndDirection
  } = (0, _hooks.useStylesUtils)();
  const {
    fontFamily,
    direction
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    view = 'default',
    gradientFrom,
    gradientTo = gradientFrom,
    angle = '180deg',
    color
  } = props;
  const ccItemTagStyle = (0, _react.useMemo)(() => {
    const viewProps = () => {
      if (view === 'horizontal') {
        return {
          fontSize: pxToRem(11),
          padding: `0 ${pxToRem(10)}`,
          minWidth: pxToRem(35.29),
          height: pxToRem(14.7),
          lineHeight: pxToRem(14.7),
          boxSizing: 'border-box'
        };
      }
      return {};
    };
    const ccItemTag = (0, _css.css)({
      fontFamily: fontFamily,
      fontSize: pxToRem(16),
      display: 'inline-flex',
      position: 'relative',
      justifyContent: 'center',
      alignItems: 'center',
      padding: `0 ${pxToRem(16)}`,
      borderRadius: pxToRem(4),
      zIndex: 1,
      ...viewProps(),
      background: `linear-gradient(${angle}, ${gradientFrom} 35%, ${gradientTo} 100%)`,
      color: color
    });
    const ccItemTagSpout = (0, _css.css)({
      position: 'absolute',
      width: pxToRem(8),
      height: pxToRem(8),
      backgroundColor: gradientFrom,
      top: 0,
      ...setEndDirection(-3),
      transform: direction === 'rtl' ? 'skew(-60deg, 0deg) rotateX(45deg)' : 'skew(60deg, 0deg) rotateX(-45deg)'
    });
    return {
      ccItemTag,
      ccItemTagSpout
    };
  }, [angle, color, direction, fontFamily, gradientFrom, gradientTo, pxToRem, setEndDirection, view]);
  return {
    'cc-Item__tag': ccItemTagStyle.ccItemTag,
    'cc-Item__tag__spout': ccItemTagStyle.ccItemTagSpout
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;